var render = function () {
  var _vm$row, _vm$row2, _vm$row3, _vm$row4, _vm$row5, _vm$row8, _vm$row9, _vm$row10, _vm$row11;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "ok-disabled": _vm.formSubmitted,
      "id": "uploadFileModal",
      "centered": true,
      "title": _vm.modalTitle,
      "hide-footer": true,
      "size": "md",
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.getPolicyDetails,
      "hidden": function hidden($event) {
        return _vm.hideModal();
      }
    }
  }, [_c('form', [_c('label', {
    attrs: {
      "for": "plan"
    }
  }, [_vm._v(" " + _vm._s(((_vm$row = _vm.row) === null || _vm$row === void 0 ? void 0 : _vm$row.status) === "submitted" ? "Selected Plan" : "Select Plan") + " ")]), _c('span', {
    staticClass: "input-required"
  }, [_vm._v(" * ")]), _c('br'), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.$v.form.plan_id.$model,
      expression: "$v.form.plan_id.$model"
    }],
    staticClass: "form-control w-100 mb-3",
    attrs: {
      "state": _vm.validateState('plan_id'),
      "disabled": ((_vm$row2 = _vm.row) === null || _vm$row2 === void 0 ? void 0 : _vm$row2.status) === 'submitted'
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.$v.form.plan_id, "$model", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s("Please Select a Plan"))]), _vm._l(_vm.plan_details, function (plan) {
    return _c('option', {
      key: plan.policy_id + '-' + plan.plan_id,
      domProps: {
        "value": plan.plan_id
      }
    }, [_vm._v(" " + _vm._s(plan.plan_name) + " ")]);
  })], 2), _vm.showError('plan_id') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Please select a plan ")]) : _vm._e(), _c('label', {
    attrs: {
      "for": "file"
    }
  }, [_vm._v(_vm._s(_vm.fileLabel))]), ((_vm$row3 = _vm.row) === null || _vm$row3 === void 0 ? void 0 : _vm$row3.status) !== 'submitted' ? [_c('span', {
    staticClass: "input-required"
  }, [_vm._v(" * ")]), _c('br'), _c('input', {
    ref: "fileInput",
    staticClass: "w-100 mb-3",
    attrs: {
      "type": "file",
      "id": "fileInput",
      "name": "fileInput",
      "multiple": "",
      "disabled": ((_vm$row4 = _vm.row) === null || _vm$row4 === void 0 ? void 0 : _vm$row4.status) === 'submitted'
    },
    on: {
      "change": _vm.fileSelected
    }
  }), _c('button', {
    staticClass: "choose-file-btn",
    attrs: {
      "type": "button",
      "disabled": ((_vm$row5 = _vm.row) === null || _vm$row5 === void 0 ? void 0 : _vm$row5.status) === 'submitted'
    },
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_vm._v(" Drop files here or \"Browse\" ")]), _vm.showError('files') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Please Upload file ")]) : _vm._e()] : _vm._e(), _c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l(_vm.form.files, function (file, index) {
    var _vm$row6;
    return _c('div', {
      key: "uploaded-".concat(file.id || "".concat(file.filename, "-").concat(index)),
      staticClass: "mb-2 file-name-wrap pl-2 pb-1"
    }, [_c('span', {
      staticClass: "pr-3 "
    }, [_vm._v(_vm._s(file.name))]), ((_vm$row6 = _vm.row) === null || _vm$row6 === void 0 ? void 0 : _vm$row6.status) !== 'submitted' ? _c('div', {
      staticClass: "close-icon",
      on: {
        "click": function click($event) {
          return _vm.removeFile(index);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times ml-2"
    })]) : _vm._e()]);
  }), 0), _vm.isEdit && _vm.form.file_lists && _vm.form.file_lists.length > 0 ? [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l(_vm.form.file_lists, function (file, index) {
    var _vm$row7;
    return _c('div', {
      key: "fileList-".concat(file.filename, "-").concat(index),
      staticClass: "mb-2 file-name-wrap pl-2 pb-1"
    }, [_c('span', {
      staticClass: "pr-3"
    }, [_vm._v(_vm._s(file.filename))]), ((_vm$row7 = _vm.row) === null || _vm$row7 === void 0 ? void 0 : _vm$row7.status) !== 'submitted' ? _c('div', {
      staticClass: "close-icon",
      on: {
        "click": function click($event) {
          return _vm.removeFileLists(file.id, index);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times ml-2"
    })]) : _vm._e()]);
  }), 0)] : _vm._e(), ((_vm$row8 = _vm.row) === null || _vm$row8 === void 0 ? void 0 : _vm$row8.status) === 'submitted' && _vm.form.description ? [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Remarks")]), _c('br'), ((_vm$row9 = _vm.row) === null || _vm$row9 === void 0 ? void 0 : _vm$row9.status) === 'submitted' ? _c('p', [_vm._v(_vm._s(_vm.form.description))]) : _vm._e()] : ((_vm$row10 = _vm.row) === null || _vm$row10 === void 0 ? void 0 : _vm$row10.status) !== 'submitted' ? [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Remarks")]), _c('br'), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.description,
      expression: "form.description"
    }],
    staticClass: "w-100",
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": _vm.form.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value);
      }
    }
  })] : _vm._e(), ((_vm$row11 = _vm.row) === null || _vm$row11 === void 0 ? void 0 : _vm$row11.status) !== 'submitted' ? _c('div', {
    staticClass: "submit-btn"
  }, [_c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submitFiles($event);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "Update" : "Submit") + " ")])]) : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }